module.exports = __webpack_public_path__ + "img/IMG_3945_FoamcoreMatted.0a1a8340.jpg";